export default __webpack_public_path__ + "static/media/1482.febcda8f.png";